import barba from "@barba/core";
import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { delay, paginationControls } from "../components/utils";
import { cluesInit } from "../components/clue";
import { initNarrative } from "../components/narrative";
import { setStoreQuestionValue, getStoreQuestionValue } from "../components/stores";
import { wysiwyg } from "../components/wysiwyg";
import { workbook } from "../components/workbook";
import { audio } from "../components/audio";

const escape_q8 = () => {
    delay(500).then(() => {

    // --------------------------------------------------
    // question
    // --------------------------------------------------
    let questionIndex = 8;
    let questionPart = 0;
    let questionPart2 = 1;
    let sliderVal = 0;

    // --------------------------------------------------
    // methods
    // --------------------------------------------------
    paginationControls(questionIndex);
    cluesInit();
    initNarrative();
    wysiwyg();
    workbook();
    audio();
  
    // --------------------------------------------------
    // modify storage
    // --------------------------------------------------

    // elems
    let textarea = document.querySelector('#working');

    // get localStorage
    let storedValue = getStoreQuestionValue("assessment", "questions", questionIndex, questionPart);
    let storedValue2 = getStoreQuestionValue("assessment", "questions", questionIndex, questionPart2);
    if(storedValue) { textarea.value = storedValue; }
    if(storedValue2) { sliderVal = storedValue2; }

    // set localStorage
    const setLocalStorage = (link) => {
        setStoreQuestionValue("assessment", "questions", questionIndex, questionPart, textarea.value);
        setStoreQuestionValue("assessment", "questions", questionIndex, questionPart2, sliderVal);
        barba.go(link);
    }

    // --------------------------------------------------
    // SLIDER
    // --------------------------------------------------

    let range = document.querySelector(".range");
    let output = document.querySelector(".js-probability");
    let rangeThumb = document.querySelector(".range__thumb");
    let w = range.getBoundingClientRect().width;
    let draggable_snap_distance = (w / 100) * 10;
    Draggable.create(rangeThumb, {
        type: "rotation",
        bounds: range,
        type: "x",
        liveSnap: function (value) {
            let snapTo = Math.round(value / draggable_snap_distance) * draggable_snap_distance;
            sliderVal = snapTo / w;
            output.textContent = sliderVal;
        return snapTo;
        },
    });
    gsap.set(rangeThumb, { x: sliderVal * w });

    // --------------------------------------------------
    // slide navigation
    // --------------------------------------------------
    const next = document.querySelector(".js-next");
    const prev = document.querySelector(".js-prev");
    if(prev){
        prev.addEventListener("click", (e) => {
            e.preventDefault();
            setLocalStorage(e.target.href);
        });
    }
    if(next){
        next.addEventListener("click", (e) => {
            e.preventDefault();
            setLocalStorage(e.target.href);
        });
    }
    
});
};

export { escape_q8 };
